<template>
  <div class="news">
    <div class="centered">
      <router-link :to="{ name: 'NewsCreator' }" class="button-wrapper">
        <a class="button is-info">+</a>Добавить новость
      </router-link>
    </div>
    <div class="news-container">
      <div class="is-multiline documents" v-if="newsObject">
        <b-table html
          :data="newsObject"
          :bordered="false"
          :striped="false"
          :narrowed="false"
          :selectable="false"
          :checkable="true"
          :mobile-cards="false"
          :paginated="true"
          :per-page="15"
          render-html
          @dblclick="edit"
          @check="checked">
          <b-table-column field="date" label="Дата публикации" sortable :format="formatDate"></b-table-column>
          <b-table-column field="title" label="Заголовок" sortable></b-table-column>
        </b-table>
        <div>
          <button class="button is-danger" :disabled="!newsObject.length" @click="deleteItems">Удалить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import NewsItem from 'components/About/NewsItem'

export default {
  name: 'News',
  data () {
    return {
      updateTimer: 0,
      checkItems: []
    }
  },
  computed: {
    ...mapState(['news']),
    newsObject () {
      return deepcopy(this.news)
    }
  },
  methods: {
    ...mapActions(['getNews', 'addNews', 'deleteNews']),
    edit (news, e) {
      this.$router.push({ name: 'NewsEditor', params: { id: news.id } })
    },
    checked (items, item) {
      this.checkItems = items
    },
    formatDate (value, row) {
      return `<span class="tag is-primary">
        ${new Date(value).toLocaleDateString()}
      </span>`
    },
    deleteItems () {
      this.$dialog.confirm({
        message: 'Действительно удалить?',
        onConfirm: () => {
          for (const item of this.checkItems) {
            this.deleteNews(item.id)
            .then(() => this.$forceUpdate())
          }
          this.checkItems = []
        }
      })
    }
  },
  created () {
    this.getNews()
  },
  components: { NewsItem }
}
</script>

<style scoped>
.news-container {
  max-width: 630px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// News.vue?4b4e2bbc